const e = {
  size: "medium"
};
export {
  e as defaultCheckboxProps
};
//# sourceMappingURL=const.mjs.map
